import type { SortOrder } from '@rss/shared';

/** The names of the two article orders (#31). */
export const SORT_LABELS: Record<SortOrder, string> = {
  newest: 'Newest first',
  oldest: 'Oldest first',
};
